import { render, staticRenderFns } from "./reportecorreccionespuntuales.vue?vue&type=template&id=5dadb690"
import script from "./reportecorreccionespuntuales.vue?vue&type=script&lang=js"
export * from "./reportecorreccionespuntuales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports